import script from "./ComicModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicModal.vue?vue&type=script&setup=true&lang=js"

import "./ComicModal.vue?vue&type=style&index=0&id=798374b4&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798374b4"]])

export default __exports__